{
	"title": "Facturas",
	"buttonShowMoreInvoicesTitle": "Mostrar más facturas",
	"invoicesTableHeaders": {
		"date": "Fecha",
		"invoiceNumber": "Número de factura",
		"deliveredQuantity": "Cantidad entregada",
		"bundledCarbonSavings": "Reducciones de carbono combinadas",
		"transactionId": "ID de transacción"
	},
	"errorMessage": "No se pudieron cargar las facturas"
}
